import sodium from "libsodium-wrappers";

/**
 * libsodium loads its WASM asynchronously. Call `ready()` and await it once
 * before using any primitive; subsequent calls resolve immediately.
 */
export type Sodium = typeof sodium;

let initialized: Promise<Sodium> | null = null;

export function ready(): Promise<Sodium> {
  if (!initialized) {
    initialized = sodium.ready.then(() => sodium);
  }
  return initialized;
}
